import styled from "styled-components";

import EditableTextContainer from "@EditArticleContainer/shared/components/EditableTextContainer/EditableTextContainer";
import UpdateButton from "@EditArticleContainer/shared/components/UpdateButton/UpdateButton";

export const ParagraphKeyCommentsListWrapper = styled.div`
  position: relative;
`;

export const ParagraphKeyCommentsListUpdateButton = styled(UpdateButton)`
  position: absolute;
  left: -1.6rem;
  top: 0;
  transform: translateX(-100%);
`;

export const CommentsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const QuoteContent = styled(EditableTextContainer)`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-size: 2rem;
  font-weight: 500;
  line-height: 160%;
  align-self: stretch;
`;

export const SpokespersonContent = styled(EditableTextContainer)`
  flex: 1;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-size: 2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
`;
